const JsMaterialDIndicator = {
	init () {

		/*              __
	                   / _)         
	            .-^^^-/ /          
	        __/       /              
	        <__.|_|-|_|  

	        The Emagine Dinosaur says; "Material Design gots slidey indicators, why can't we?".          
	    */

		// Js fiddle example, handles this
		// https://jsfiddle.net/czf9kjfd/32/
		$.fn.RegisterTabBar = function (id) {
		    var $ele = $(this);

		    if ($ele.prop("tagName") && $ele.prop("tagName").toLowerCase() == "ul" && id != undefined) {

		        $ele.attr("data-style-id", id);

		        $("<style type='text/css'></style>").attr("id", id).appendTo($("body"));

		        // Click for tabs I guess, mouse events for links, as you'll be navigating away from the page
		        $ele.find("li").on("click", function () {
		        	indicatorPosition($ele, $(this));
		        });

		        $ele.find("li").on("mouseover", function () {
		        	indicatorPosition($ele, $(this));
		        });

		        $ele.find("li").on("mouseout", function () {
		        	indicatorPosition($ele, $(this), true);
		        });
		    }
		    return $ele;
		}

		function indicatorPosition ($ele, $li, $mouseout = false) {
			var $li = $li;
		 	var ActiveIndex = $ele.find(".active");

            var CurrentIndex = $ele.find(".indicator-active").removeClass("indicator-active").index();

            if ( $mouseout == true ) {
				var ClickedIndex = ActiveIndex.addClass("indicator-active").index();
            } else {
            	var ClickedIndex = $li.addClass("indicator-active").index();
            }

            function SetStyle($ele, $li, ActiveIndex, $mouseout, IsToLeft, IsToTop) {
                var ID = $ele.attr("data-style-id");
                if (ID == undefined) return;
                if ($ele.width() <= 0) {
                    setTimeout(function () { SetStyle($ele, $li, IsToLeft); }, 100);
                    return;
                }

                if ($ele.height() <= 0) {
                    setTimeout(function () { SetStyle($ele, $li, IsToTop); }, 100);
                    return;
                }

                $("style#" + ID).text(
                    "ul[data-style-id='" + ID + "']:before { " +
                        "left: " + $li.position().left + "px; " +
                        "right: " + ($ele.width() - $li.position().left - $li.outerWidth()) + "px; " +
                        "top" + $li.position().top + "px; " +
                        "bottom: " + ($ele.height() - $li.position().top - $li.outerHeight()) + "px; " +
                        // "-webkit-transition: left " + (IsToLeft ? ".45s" : ".8s") + ", right " + (IsToLeft ? ".9s" : ".3s") + "; " +
                        // "transition: left " + (IsToLeft ? ".45s" : ".8s") + ", right " + (IsToLeft ? ".9s" : ".3s") + "; " +
                        "-webkit-transition: top" + (IsToTop ? ".45s" : ".8s") + ", right " + (IsToLeft ? ".9s" : ".3s") + ", bottom " + (IsToTop ? ".9s" : ".3s") + ", left " + (IsToLeft ? ".45s" : ".8s") + "; " +
                        "transition: top" + (IsToTop ? ".45s" : ".8s") + ", right " + (IsToLeft ? ".9s" : ".3s") + ", bottom " + (IsToTop ? ".9s" : ".3s") + ", left " + (IsToLeft ? ".45s" : ".8s") + "; " +
                    "} "
                );
            }

            if ( $mouseout == true ) {
            	SetStyle($ele, ActiveIndex, ClickedIndex < CurrentIndex);
            } else {
            	SetStyle($ele, $li, ClickedIndex < CurrentIndex);
            }
		}

	}
};

export default JsMaterialDIndicator;


// WEBPACK FOOTER //
// ./src/js/modules/material-indicator.js